export const getFile = (file) => {
  if (!file) return file;
  if (/^https?:\/\//i.test(file)) return file;
  return `${import.meta.env.VITE_DIGITALOCEAN_SPACE_URL}/${file}`;
};

export const uploadFile = async (path, file) => {
  const formData = new FormData();
  formData.append("path", path);
  formData.append("file", file);

  try {
    const response = await fetch(import.meta.env.VITE_N8N_UPLOAD_URL, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) return false;

    return true;
  } catch (err) {
    console.log("Error", err);
    return false;
  }
};
